export default function mapLotterySlugToMachine(lotterySlug: string): string {
    switch (true) {
        case /keno-ny/.test(lotterySlug):
            return 'gMachine01_02_80';
        case /keno/.test(lotterySlug):
            return 'gMachine01_02';
        // case /world-raffle/.test(lotterySlug):
        //     return 'machine01_01';
        case /pick-2/.test(lotterySlug):
            return 'machine02_01_01';
        case /pick-3/.test(lotterySlug):
            return 'machine03_01_01_01';
        case /pick-4/.test(lotterySlug):
            return 'machine04_01_01_01_01';
        case /pick-5/.test(lotterySlug):
            return 'machine05_01_01_01_01_01';
        case /borlette/.test(lotterySlug):
            return 'machine07_01_01_01_01_01_01_01';
        case /nap-2/.test(lotterySlug):
            return 'machine01_05';
        case /world-million/.test(lotterySlug):
            return 'machine02_05_02';
        case /world-x/.test(lotterySlug):
            return 'machine02_05_02';
        case /mega-jackpot/.test(lotterySlug):
            return 'machine02_05_02';
        case /chance-5/.test(lotterySlug):
            return 'machine01_05';
        default:
            return null;
    }
}
